import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  loginWithGoogle: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/google/callback/`,
  },
  loginWithSSO: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/saml`,
  },
  loginWithMicrosoft: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/microsoft/login/`,
  },
  ssoDiscovery: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/sso-discovery`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const loginWithGoogle = async (params) => {
  const res = await resource.loginWithGoogle(params)

  return res.body
}

const loginWithSSO = async (params) => {
  const res = await resource.loginWithSSO(params)

  return res.body
}

const loginWithMicrosoft = async (params) => {
  const res = await resource.loginWithMicrosoft(params)

  return res.body
}

// Wraps the same SSO discovery endpoint SsoEnforcementMixin uses on the login/register email
// field, so both read one source of truth. Keyed on the user's own email, independent of the
// selected workspace. Rejects on any network/server error so the caller can fail open WITHOUT
// caching the email as "checked" — a swallowed error would let a transient failure permanently
// suppress the SSO redirect for that email (the caller's dedup guard never retries it).
const isSsoEnforcedForEmail = async (email) => {
  const res = await resource.ssoDiscovery({ email })

  return res.body?.enforceSsoLogin === true
}

export default {
  initResource,
  loginWithGoogle,
  loginWithSSO,
  loginWithMicrosoft,
  isSsoEnforcedForEmail,
}
